"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectedItemWithSpecificTypeSchema = exports.selectedItemSchema = void 0;
const zod_1 = require("zod");
const enum_schema_1 = require("./enum.schema");
exports.selectedItemSchema = zod_1.z.object({
    id: zod_1.z.number(),
});
const selectedItemWithSpecificTypeSchema = (value, omit) => zod_1.z
    .object({
    id: (0, enum_schema_1.enumSchema)(value, omit),
})
    .strict();
exports.selectedItemWithSpecificTypeSchema = selectedItemWithSpecificTypeSchema;
//# sourceMappingURL=selectedItem.schema.js.map